import cn from "classnames";
// import { useState } from "react";
import { NavLink } from "react-router-dom";
// {useLocation }
// import Modal from "../Modal";
import styles from "./header.module.css";
import { motion } from "framer-motion";

// import Menu from "./Menu";

const Header = () => {
  // const [modal, setModal] = useState(false);
  // const [dropdown, setDropdown] = useState(false);

  // const location = useLocation();
  // const { pathname } = location;

  // const splitLocation = pathname.split("/");

  // const closeModal = () => {
  //   setModal(false);
  // };

  // const openModal = () => {
  //   setModal(!modal);
  // };

  // const closeDropdown = () => {
  //   setDropdown(false);
  // };

  // const openDropdown = () => {
  //   setDropdown(!dropdown);
  // };

  const fallowLink = (url) => {
    // console.log("click");
    window.open(url, "_blank").focus();
  };
  const socials = [
    {
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 25 25"
          strokeWidth="1.5"
          stroke="#777E91"
          fill="none"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z" />
        </svg>
      ),
      url: "https://unsplash.com/@krutota",
    },
    {
      svg: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="2"
            width="20"
            height="20"
            rx="4"
            stroke="#777E91"
            strokeWidth="1.5"
          />
          <circle cx="18" cy="6" r="1" fill="#777E91" />
          <circle cx="12" cy="12" r="5" stroke="#777E91" strokeWidth="1.5" />
        </svg>
      ),
      url: "https://instagram.com/kruto.graphy?igshid=NzAzN2Q1NTE=",
    },
    {
      svg: (
        <svg
          fill="#777e91"
          height="23"
          width="23"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 189.47 189.47"
          stroke="#777e91"
          strokeWidth="0.0018947300000000003"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#CCCCCC"
            strokeWidth="3.0315680000000005"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path d="M152.531,179.476c-1.48,0-2.95-0.438-4.211-1.293l-47.641-32.316l-25.552,18.386c-2.004,1.441-4.587,1.804-6.914,0.972 c-2.324-0.834-4.089-2.759-4.719-5.146l-12.83-48.622L4.821,93.928c-2.886-1.104-4.8-3.865-4.821-6.955 c-0.021-3.09,1.855-5.877,4.727-7.02l174.312-69.36c0.791-0.336,1.628-0.53,2.472-0.582c0.302-0.018,0.605-0.018,0.906-0.001 c1.748,0.104,3.465,0.816,4.805,2.13c0.139,0.136,0.271,0.275,0.396,0.42c1.11,1.268,1.72,2.814,1.835,4.389 c0.028,0.396,0.026,0.797-0.009,1.198c-0.024,0.286-0.065,0.571-0.123,0.854L159.898,173.38c-0.473,2.48-2.161,4.556-4.493,5.523 C154.48,179.287,153.503,179.476,152.531,179.476z M104.862,130.579l42.437,28.785L170.193,39.24l-82.687,79.566l17.156,11.638 C104.731,130.487,104.797,130.533,104.862,130.579z M69.535,124.178l5.682,21.53l12.242-8.809l-16.03-10.874 C70.684,125.521,70.046,124.893,69.535,124.178z M28.136,86.782l31.478,12.035c2.255,0.862,3.957,2.758,4.573,5.092l3.992,15.129 c0.183-1.745,0.974-3.387,2.259-4.624L149.227,38.6L28.136,86.782z"></path>{" "}
            </g>
          </g>
        </svg>
      ),
      url: "https://t.me/krutography",
    },

    {
      svg: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.66725 20L7.64668 20.7497C7.65353 20.7499 7.66039 20.75 7.66725 20.75V20ZM3 4.88889L3.5973 4.43531C3.40257 4.17887 3.06587 4.07535 2.76071 4.17809C2.45554 4.28082 2.25 4.56689 2.25 4.88889H3ZM8.4 16.4444L8.92703 16.9781C9.1355 16.7722 9.20498 16.4637 9.10491 16.1883C9.00484 15.9129 8.75355 15.721 8.46152 15.697L8.4 16.4444ZM3 18.9503L2.92881 18.2037C2.63318 18.2319 2.38203 18.4319 2.28832 18.7137C2.19461 18.9955 2.276 19.306 2.49587 19.5056L3 18.9503ZM11.5889 8.96808V9.71808C11.8182 9.71808 12.0349 9.61318 12.1772 9.43333C12.3194 9.25349 12.3716 9.01845 12.3188 8.79532L11.5889 8.96808ZM21 4.88889L21.7148 5.11581C21.8205 4.78294 21.6824 4.42119 21.3819 4.24338C21.0813 4.06556 20.6977 4.11876 20.4569 4.37166L21 4.88889ZM19.0934 8.22229L18.6845 7.59355C18.4756 7.72941 18.3478 7.96016 18.3435 8.20932L19.0934 8.22229ZM18.2303 5.46181L17.6397 5.92409C17.7316 6.04143 17.8563 6.12874 17.9979 6.17491L18.2303 5.46181ZM12.2266 8C12.2266 6.17014 13.6304 4.75 15.286 4.75V3.25C12.7338 3.25 10.7266 5.41158 10.7266 8H12.2266ZM7.87297 15.9108C6.64696 17.1217 4.70491 18.0344 2.92881 18.2037L3.07119 19.6969C5.18808 19.4951 7.45304 18.4338 8.92703 16.9781L7.87297 15.9108ZM11.5889 8.21808C9.41235 8.21808 6.0951 7.7246 3.5973 4.43531L2.4027 5.34246C5.3049 9.16429 9.18765 9.71808 11.5889 9.71808V8.21808ZM12.3188 8.79532C12.2587 8.54165 12.2266 8.27535 12.2266 8H10.7266C10.7266 8.3923 10.7724 8.77454 10.8591 9.14084L12.3188 8.79532ZM7.68782 19.2503C7.11342 19.2345 6.19427 19.1649 5.32735 19.0096C4.89389 18.932 4.49028 18.8358 4.15659 18.7211C3.80851 18.6015 3.60127 18.4832 3.50413 18.395L2.49587 19.5056C2.81745 19.7976 3.25212 19.9964 3.66909 20.1397C4.10046 20.288 4.58504 20.4005 5.06286 20.4861C6.01851 20.6573 7.01426 20.7324 7.64668 20.7497L7.68782 19.2503ZM20.2852 4.66196C20.2064 4.91014 20.0456 5.49166 19.7598 6.1201C19.464 6.77086 19.0959 7.326 18.6845 7.59355L19.5023 8.85104C20.2878 8.34021 20.8025 7.45109 21.1253 6.74095C21.4584 6.00851 21.6524 5.31252 21.7148 5.11581L20.2852 4.66196ZM18.3435 8.20932C18.2371 14.3599 13.465 19.25 7.66725 19.25V20.75C14.3512 20.75 19.7239 15.1344 19.8433 8.23527L18.3435 8.20932ZM17.9979 6.17491C18.6255 6.3794 19.308 6.38664 19.9164 6.25698C20.5182 6.12875 21.1199 5.85046 21.5431 5.40612L20.4569 4.37166C20.2969 4.53962 19.9987 4.70578 19.6038 4.78992C19.2156 4.87264 18.8048 4.86019 18.4627 4.74871L17.9979 6.17491ZM15.286 4.75C16.2239 4.75 17.072 5.1988 17.6397 5.92409L18.8209 4.99952C17.9913 3.93973 16.7204 3.25 15.286 3.25V4.75ZM8.46152 15.697C7.26444 15.5984 3.75 13.6473 3.75 4.88889H2.25C2.25 13.9082 5.93556 16.9941 8.33848 17.1919L8.46152 15.697Z"
            fill="#777E91"
          />
        </svg>
      ),
      url: "https://twitter.com/krutotasya",
    },
   
  ];

  return (
    <header className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.main_wrapper}>
          <NavLink className={cn("body-2-bold", styles.logo)} to="/">
            {/* Asya Krutota<span>.</span> */}
            <img src="/logo.PNG" alt="logo" />
          </NavLink>
          {/* <div className={styles.break} /> */}
          {/* <div className={styles.mini_wrapper}>
            <NavLink
              className={cn(
                splitLocation[1] === "/"
                  ? "button-small active"
                  : "button-small"
              )}
              to="/"
            >
              Home V1
            </NavLink>
            <NavLink
              className={cn(
                splitLocation[1] === "homev2"
                  ? "button-small active"
                  : "button-small"
              )}
              to="/homev2"
            >
              Home V2
            </NavLink>
            <NavLink
              className={cn(
                splitLocation[1] === "homev3"
                  ? "button-small active"
                  : "button-small"
              )}
              to="/homev3"
            >
              Home V3
            </NavLink>
          </div> */}
        </div>

        <div className={styles.wrapper}>
          {/* <button
            onClick={openDropdown}
            className={cn("", styles.responsive_button)}
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.8334 13.9167C12.4192 13.9167 12.0834 14.2524 12.0834 14.6667C12.0834 15.0809 12.4192 15.4167 12.8334 15.4167V13.9167ZM22 15.4167C22.4143 15.4167 22.75 15.0809 22.75 14.6667C22.75 14.2524 22.4143 13.9167 22 13.9167V15.4167ZM12.8334 21.25C12.4192 21.25 12.0834 21.5858 12.0834 22C12.0834 22.4142 12.4192 22.75 12.8334 22.75V21.25ZM31.1667 22.75C31.5809 22.75 31.9167 22.4142 31.9167 22C31.9167 21.5858 31.5809 21.25 31.1667 21.25V22.75ZM22 28.5833C21.5858 28.5833 21.25 28.9191 21.25 29.3333C21.25 29.7475 21.5858 30.0833 22 30.0833V28.5833ZM31.1667 30.0833C31.5809 30.0833 31.9167 29.7475 31.9167 29.3333C31.9167 28.9191 31.5809 28.5833 31.1667 28.5833V30.0833ZM12.8334 15.4167H22V13.9167H12.8334V15.4167ZM12.8334 22.75H31.1667V21.25H12.8334V22.75ZM22 30.0833H31.1667V28.5833H22V30.0833Z"
                fill="#28303F"
              />
            </svg>
          </button> */}

          <div className={styles.marketing}>
            <div className={styles.social_wrapper}>
              {socials.map((item, index) => (
                <motion.div
                  variants={item}
                  key={index}
                  className={styles.social_icon}
                  onClick={() => fallowLink(item.url)}
                >
                  {item.svg}
                </motion.div>
              ))}
            </div>
            {/* <a
              className={cn("button button-stroke", styles.purchase_button)}
              href="https://linktr.ee/magrathea_nft"
              target="_blank"
              rel="noreferrer"
            >
              Purchase $20 000
            </a> */}
            {/* <button
              className={cn("button-svg", styles.message_button)}
              onClick={openModal}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 9.25C7.58579 9.25 7.25 9.58579 7.25 10C7.25 10.4142 7.58579 10.75 8 10.75V9.25ZM16 10.75C16.4142 10.75 16.75 10.4142 16.75 10C16.75 9.58579 16.4142 9.25 16 9.25V10.75ZM8 13.25C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75V13.25ZM12 14.75C12.4142 14.75 12.75 14.4142 12.75 14C12.75 13.5858 12.4142 13.25 12 13.25V14.75ZM11 3.75H13V2.25H11V3.75ZM2.75 17V12H1.25V17H2.75ZM13 20.25H6V21.75H13V20.25ZM1.25 17C1.25 19.6234 3.37665 21.75 6 21.75V20.25C4.20507 20.25 2.75 18.7949 2.75 17H1.25ZM21.25 12C21.25 16.5563 17.5563 20.25 13 20.25V21.75C18.3848 21.75 22.75 17.3848 22.75 12H21.25ZM13 3.75C17.5563 3.75 21.25 7.44365 21.25 12H22.75C22.75 6.61522 18.3848 2.25 13 2.25V3.75ZM11 2.25C5.61522 2.25 1.25 6.61522 1.25 12H2.75C2.75 7.44365 6.44365 3.75 11 3.75V2.25ZM8 10.75H16V9.25H8V10.75ZM8 14.75H12V13.25H8V14.75Z"
                  fill="#FCFCFD"
                />
              </svg>
            </button> */}
          </div>
        </div>
      </div>

      {/* {dropdown ? (
        <section className={cn("background")}>
          <div className={cn("align")}>
            <Menu
              openModal={openModal}
              closeModal={closeDropdown}
              setModal={setDropdown}
            />
          </div>
        </section>
      ) : null}

      {modal ? (
        <section className={cn("background")}>
          <div className={cn("align")}>
            <Modal closeModal={closeModal} setModal={setModal} />
          </div>
        </section>
      ) : null} */}
    </header>
  );
};

export default Header;
